/* DSL Auto-apply discount uit URL */
(function(){
  var p = new URLSearchParams(location.search);
  var code = p.get("dc") || p.get("discount");
  if (!code) return;
  fetch("/discount/" + encodeURIComponent(code), {method:"GET", credentials:"same-origin", redirect:"manual"}).then(function(){
    if (window.DSL_AB) window.DSL_AB.track("discount_url_apply", {code: code});
  }).catch(function(){});
  // Toon banner
  var b = document.createElement("div");
  b.className = "dsl-dc-applied";
  b.innerHTML = "✓ Kortingscode <strong>" + code + "</strong> wordt toegepast bij checkout.";
  b.setAttribute("role","status");
  document.body.insertBefore(b, document.body.firstChild);
  setTimeout(function(){ b.style.opacity = "0"; setTimeout(function(){ b.remove(); }, 400); }, 5000);
})();